import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

/** Removed from the shared localStorage by `AuthService.clearLocalSession()`: its loss in another tab is the sign-out signal. */
export const SIGNED_IN_STORAGE_KEY = 'isLoggedIn';

/** Left running: the customer display saves nothing and faces the customer. */
const UNAFFECTED_ROUTES = ['/pos/customer-display'];

/** Reloads this tab once another tab of the same browser signs out, so the route guards send it to sign in. */
@Injectable({
  providedIn: 'root'
})
export class CrossTabSignOutService implements OnDestroy {
  private watching = false;
  private signedOut = false;

  constructor(
    private ngZone: NgZone,
    private router: Router
  ) { }

  watch(): void {
    if (this.watching) return;
    this.watching = true;
    // Outside Angular, so other tabs' localStorage writes trigger no change detection here.
    this.ngZone.runOutsideAngular(() => window.addEventListener('storage', this.onStorage));
  }

  ngOnDestroy(): void {
    window.removeEventListener('storage', this.onStorage);
  }

  private readonly onStorage = (event: StorageEvent): void => {
    if (event.key !== SIGNED_IN_STORAGE_KEY || event.oldValue !== 'true' || event.newValue !== null) return;
    if (this.signedOut || UNAFFECTED_ROUTES.some(route => this.router.url.startsWith(route))) return;

    this.signedOut = true;
    this.reload();
  };

  /** A full reload, never an in-app redirect, so this tab cannot reach Keycloak before the other tab's logout. */
  protected reload(): void {
    window.location.reload();
  }
}
